import React from 'react';
import { ShieldCheckIcon, CreditCardIcon, FileTextIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './shared';
const trustItems = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 45 días'
}, {
  icon: CreditCardIcon,
  label: 'Pago seguro Mercado Pago'
}, {
  icon: FileTextIcon,
  label: '100% PDF'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 min'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-navy-deep text-white" data-id="element-115" data-mp="12a0kd8y2xwtk">
      <div className="absolute inset-0 opacity-60" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/patterns/generated-images/4fbb4e4a-f34c-408d-b2e6-11beb3e64ad2.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} aria-hidden="true" data-id="element-116" data-mp="xae5yw6imaj6" />
      <div className="absolute inset-0 bg-gradient-to-b from-navy-deep/70 via-navy-deep/85 to-navy-deep" aria-hidden="true" data-id="element-117" data-mp="3d2bjjokooxv0" />

      <div className="relative mx-auto w-full max-w-3xl px-5 py-16 text-center sm:px-6 sm:py-24" data-id="element-118" data-mp="3814ehx9xecs1">
        <p className="mx-auto mb-6 max-w-xl text-sm font-semibold uppercase tracking-wide text-gold-soft" data-id="element-119" data-mp="3j9alrqbghebh">
          CREADO POR AGENTES. PARA AGENTES.
        </p>

        <h1 className="font-display text-3xl font-extrabold leading-tight sm:text-5xl" data-id="element-120" data-mp="399bahlnnj9ux">
          El Megapack Definitivo — <span className="text-gold" data-id="element-121" data-mp="3e84rho25dizu">Agente Seguro PRO</span>
        </h1>

        <img src="https://cdn.magicpatterns.com/uploads/pTrXDYCRU5KNUYZxB9VMYd/1__2_-removebg-preview.png" alt="Megapack Agentes de Seguros PRO con sus módulos, dashboards y herramientas" className="mx-auto mt-7 w-full max-w-md rounded-2xl border border-gold/30 shadow-2xl shadow-black/30 sm:max-w-lg" data-id="element-122" data-mp="30hrf99i83i4p" />

        <p className="mx-auto mt-5 max-w-2xl text-base text-blue-100/90 sm:text-lg" data-id="element-123" data-mp="2vj7wfhyxemgk">
          Megapack Agentes de Seguros PRO — los 6 módulos, dashboards, sistema de seguimiento y bonos
          incluidos
        </p>

        <p className="mx-auto mt-8 max-w-2xl font-display text-xl font-bold leading-snug text-white sm:text-2xl" data-id="element-124" data-mp="2lmld4xm903gn">
          Cerrá pólizas en la mitad del tiempo y recuperá tus renovaciones con IA.
        </p>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-center gap-2 text-sm sm:gap-3" data-id="element-125" data-mp="ibyr8h66ta4a">
          {['Scripts listos', 'Sistemas de seguimiento', 'Cierre de objeciones'].map(b => <span key={b} className="rounded-full border border-white/15 bg-white/5 px-4 py-1.5 font-medium text-blue-50" data-id="element-126" data-mp="1b1fgx72facwt">
              {b}
            </span>)}
        </div>

        <p className="mt-6 text-base font-semibold text-blue-100 sm:text-lg" data-id="element-127" data-mp="111esx7tlz8ma">
          Sin perseguir. Sin improvisar. Sin perder domingos.
        </p>

        <div className="mt-9 flex justify-center" data-id="element-128" data-mp="3lsyun4p58wlp">
          <CTAButton size="lg" data-id="element-129" data-mp="3ltqczdtqcxu1">💥 QUIERO MI MEGAPACK AHORA</CTAButton>
        </div>

        <div className="mx-auto mt-8 flex max-w-2xl flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-blue-100/80 sm:text-sm" data-id="element-130" data-mp="3hqahwlxb75jg">
          {trustItems.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-131" data-mp="21bxy9551wsbc">
              <Icon className="h-4 w-4 text-gold-soft" aria-hidden="true" data-id="element-132" data-mp="269hegalb7f5x" />
              {label}
            </span>)}
          <span className="inline-flex items-center gap-1.5" data-id="element-133" data-mp="2b1hkmkrz34ay">🇦🇷 Para Argentina</span>
        </div>
      </div>
    </header>;
}